import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { createReferralVoucher } from './service';
import { ReferralVouchersQueryKeys } from '../../queryKeys';
import { useModal } from '@/hooks/modals/useModal';
import { ModalsKey } from '@/enums/modalsKey';
import { useNotificationService } from '@/hooks/notifications/useNotificationService';

export function useCreateReferralVoucher() {
  const queryClient: QueryClient = useQueryClient();
  const { onClose } = useModal(ModalsKey.CreateReferralVoucher);
  const { NotificationsService } = useNotificationService();

  function onSuccess() {
    NotificationsService.success({
      title: 'create_referral_voucher_success_title',
      message: 'create_referral_voucher_success_description',
    });
    queryClient.invalidateQueries({
      queryKey: [ReferralVouchersQueryKeys.Me],
    });
    onClose();
  }

  const { isPending, isError, data, error, mutate } = useMutation({
    mutationFn: createReferralVoucher,
    onSuccess,
  });

  return {
    isPending,
    isError,
    data,
    error,
    createReferralVoucher: mutate,
  };
}
